export const styles = {
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
            m: 6,
        },
    },
} as const;
